import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Row, Col, Grid } from "react-bootstrap";
import { Icon, Button, Dropdown } from "semantic-ui-react";

import Sidebar from "../../Sidebar/Sidebar";
import Input from "../../Input/Input";
import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import OSAgencyCard from "../../OSAgencyCard/OSAgencyCard";
import Pagination from "react-js-pagination";
import moment from "moment";
import ReactGA from "react-ga";
import { translate, getLanguage } from "../../Translation/Translation";

import { FETCH_URL } from "../../../utilities";

class AgenciesContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      country: [],
      prefect: [],
      municipal: [],
      activeOutPage: 1,
      activeInPage: 1,
      outgoingAgencies: [],
      incomingAgencies: [],
      filteredIncomingAgencies: [],
      filteredOutgoingAgencies: [],
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  handleChangeText(event) {
    event.preventDefault(event);
    const {
      outgoingAgencies,
      incomingAgencies,
      rawIncoming,
      rawOutgoing
    } = this.state;
    const { value } = event.target;

    if (value) {
      const filteredIncoming = incomingAgencies.filter(
        agency => agency.name.toUpperCase().indexOf(value.toUpperCase()) !== -1
      );
      const filteredOutgoing = outgoingAgencies.filter(
        agency => agency.name.toUpperCase().indexOf(value.toUpperCase()) !== -1
      );
      this.setState({
        filteredOutgoingAgencies: filteredOutgoing,
        filteredIncomingAgencies: filteredOutgoing,
        activeInPage: 1,
        activeOutPage: 1
      });
    } else {
      this.setState({
        filteredOutgoingAgencies: rawOutgoing,
        filteredIncomingAgencies: rawIncoming,
        activeInPage: 1,
        activeOutPage: 1
      });
    }
  }

  redirectToShips = () => {
    this.props.data.history.push(
      `/${this.props.data.match.params.from}/${
        this.props.data.match.params.to
      }/${this.props.data.match.params.sdate}/${
        this.props.data.match.params.edate
      }/ships`
    );
    this.setState({ redirect: true });
  };

  handlePageChangeOut = pageNumber => {
    this.setState({ activeOutPage: pageNumber });
  };

  handlePageChangeIn = pageNumber => {
    this.setState({ activeInPage: pageNumber });
  };

  fetchCountries = () => {
    fetch(
      `${FETCH_URL}/proxy.php?ws=00095892afeafcc7f393499c65cd2c4c/${getLanguage()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "text/plain"
        }
      }
    )
      .then(response => response.json())
      .then(responseJson => {
        this.setState({ country: responseJson });
        this.fetchCountryData(responseJson[1].id);
        return responseJson;
      })
      .catch(error => {
        console.error(error);
      });
  };

  fetchCountryData = countryId => {
    fetch(
      `${FETCH_URL}/proxy.php?ws=6d2bf7839787aba469120a7df1a99f50/${getLanguage()}/${countryId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "text/plain"
        }
      }
    )
      .then(response => response.json())
      .then(responseJson => {
        this.setState({
          municipal: responseJson.municipalities,
          prefect: responseJson.prefectures
        });
        return responseJson;
      })
      .catch(error => {
        console.error(error);
      });
  };

  fetchAllAgenciesForCompanyId = () => {
    const outgoingTrip = JSON.parse(localStorage.getItem("outgoingTrip")); 
    const incomingTrip = JSON.parse(localStorage.getItem("incomingTrip"));
    
    if (outgoingTrip) {
      fetch(
        `${FETCH_URL}/proxy.php?ws=a4b2006416a7e79c658a52a9d7f3b63a/${getLanguage()}/${
          outgoingTrip.company.id
        }`,
        {
          method: "GET"
        }
      )
        .then(response => response.json())
        .then(responseJson => {
          this.setState({
            outgoingAgencies: responseJson,
            rawOutgoing: responseJson
          });
        })
        .catch(error => {
          console.error(error);
        });
    } 
  }

  componentDidMount() {
    window.scrollTo(0,0);
    this.fetchCountries();

    let outgoingTrip = JSON.parse(localStorage.getItem("outgoingTrip"));
    let incomingTrip = JSON.parse(localStorage.getItem("incomingTrip"));

    let arrivalLocation = JSON.parse(localStorage.getItem("arrivalLocation"));
    let departureLocation = JSON.parse(
      localStorage.getItem("departureLocation")
    );

    if (outgoingTrip) {

      fetch(
        `${FETCH_URL}/proxy.php?ws=a4b2006416a7e79c658a52a9d7f3b63a/${getLanguage()}/${
          outgoingTrip.company.id
        }`,
        {
          method: "GET"
        }
      )
        .then(response => response.json())
        .then(responseJson => {
          this.setState({
            outgoingAgencies: responseJson,
            filteredOutgoingAgencies: responseJson,
            rawOutgoing: responseJson
          });
        })
        .catch(error => {
          console.error(error);
        });
    }

    if (
      incomingTrip &&
      this.props.data.match.params.sdate != this.props.data.match.params.edate
    ) {

      fetch(
        `${FETCH_URL}/proxy.php?ws=a4b2006416a7e79c658a52a9d7f3b63a/${getLanguage()}/${
          incomingTrip.company.id
        }`,
        {
          method: "GET"
        }
      )
        .then(response => response.json())
        .then(responseJson => {
          this.setState({
            incomingAgencies: responseJson,
            filteredIncomingAgencies: responseJson,
            rawIncoming: responseJson
          });
        })
        .catch(error => {
          console.error(error);
        });
    }

    this.setState({
      incomingTrip: incomingTrip,
      outgoingTrip: outgoingTrip,
      departureLocation: departureLocation,
      arrivalLocation: arrivalLocation
    });
  }

  countryChanged = target => {
    this.props.setCountry(target.value);
    this.setState({ activeInPage: 1, activeOutPage: 1 });
  };
  perfectureChanged = target => {
    this.props.setPerfecture(target.value);
    this.setState({ activeInPage: 1, activeOutPage: 1 });
  };
  municipalityChanged = target => {
    this.props.setMunicipality(target.value);
    this.setState({ activeInPage: 1, activeOutPage: 1 });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.agencies.countryId !== nextProps.agencies.countryId) {
      if (nextProps.agencies.countryId === "all") {
        this.fetchAllAgenciesForCompanyId();
      } else {
        this.fetchCountryData(nextProps.agencies.countryId);
      }
    }
  }

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: `/${this.props.data.data.settings.departurePortCode}/${
              this.props.data.data.settings.arrivalPortCode
            }/${this.props.data.data.settings.startDate}/${
              this.props.data.data.settings.endDate
            }/ships`
          }}
        />
      );
    }

    let country = [];
    country = [
      { key: "ALL", text: translate(getLanguage(), "ALL COUNTRIES"), value: "ALL" },
      ...this.state.country.map(country => {
        return { key: country.id, text: country.name, value: country.id };
      })
    ];

    let prefect = [];
    prefect = this.state.prefect.map(prefect => {
      return { key: prefect.id, text: prefect.name, value: prefect.id };
    });

    let municipal = [];
    let filteredMunicipalities = this.state.municipal.filter(municipality => {
      return municipality.parentId == this.props.agencies.perfectureId;
    });

    municipal = filteredMunicipalities.map(municipalities => {
      return {
        key: municipalities.id,
        text: municipalities.name,
        value: municipalities.id
      };
    });

    if (filteredMunicipalities.length == 0) {
      municipal = [{ key: -1, text: "No Results", value: -1 }];
    }

    if(this.props.agencies.countryId == "ALL"){
      prefect = [{ key: -1, text: "No Results", value: -1 }]
    }

    let agenciesOut = [];
    let filteredAgenciesOut = [];

    console.log(this.state.filteredOutgoingAgencies)
    if (this.state.filteredOutgoingAgencies) {
      if(this.props.agencies.countryId == "ALL"){
        filteredAgenciesOut = this.state.filteredOutgoingAgencies;
      }else{
        filteredAgenciesOut = this.state.filteredOutgoingAgencies.filter(agency => {
          {
            return agency.area.countryId == this.props.agencies.countryId;
          }
        });
  
        if (this.props.agencies.municipalityId) {
          filteredAgenciesOut = filteredAgenciesOut.filter(agency => {
            {
              return agency.area.id == this.props.agencies.municipalityId;
            }
          });
        }
  
        if (this.props.agencies.perfectureId) {
          filteredAgenciesOut = filteredAgenciesOut.filter(agency => {
            {
              return agency.area.parentId == this.props.agencies.perfectureId;
            }
          });
        }
      }
      

      let agenciesToMap = filteredAgenciesOut.slice(
        (parseInt(this.state.activeOutPage) - 1) * 10,
        parseInt(this.state.activeOutPage) * 10
      );

      agenciesOut = agenciesToMap.map(agency => {
        return (
          <OSAgencyCard
            from={this.props.data.data.settings.departurePortCode}
            to={this.props.data.data.settings.arrivalPortCode}
            sdate={this.props.data.data.settings.startDate}
            edate={this.props.data.data.settings.endDate}
            key={`${agency.id}${agency.address}`}
            agencyId={agency.id}
            name={agency.name}
            address={agency.address}
            tel={agency.telephone}
            fax={agency.fax}
            url={agency.bookingEngineUrl}
            webSiteUrl={agency.webSiteUrl}
            language={getLanguage()}
          />
        );
      });
    }

    let agenciesIn = [];
    let filteredAgenciesIn = [];

    if (this.state.filteredIncomingAgencies) {
      filteredAgenciesIn = this.state.filteredIncomingAgencies.filter(agency => {
        {
          return agency.area.countryId == this.props.agencies.countryId;
        }
      });

      if (this.props.agencies.municipalityId) {
        filteredAgenciesIn = filteredAgenciesIn.filter(agency => {
          {
            return agency.area.id == this.props.agencies.municipalityId;
          }
        });
      }

      if (this.props.agencies.perfectureId) {
        filteredAgenciesIn = filteredAgenciesIn.filter(agency => {
          {
            return agency.area.parentId == this.props.agencies.perfectureId;
          }
        });
      }

      let agenciesToMap = filteredAgenciesIn.slice(
        (parseInt(this.state.activeInPage) - 1) * 10,
        parseInt(this.state.activeInPage) * 10
      );

      agenciesIn = agenciesToMap.map(agency => {
        return (
          <OSAgencyCard
            from={this.props.data.data.settings.departurePortCode}
            to={this.props.data.data.settings.arrivalPortCode}
            sdate={this.props.data.data.settings.startDate}
            edate={this.props.data.data.settings.endDate}
            key={`${agency.id}${agency.address}`}
            agencyId={agency.id}
            name={agency.name}
            address={agency.address}
            tel={agency.telephone}
            fax={agency.fax}
            url={agency.bookingEngineUrl}
            webSiteUrl={agency.webSiteUrl}
            language={getLanguage()}
          />
        );
      });
    }
    return (
      <div>
        <Row style={{ margin: "0px", marginTop: "20px" }}>
          <div className="stepCounter">3</div>
          <div className="stepLabel">
            {translate(getLanguage(), "Agencies")}
          </div>
        </Row>
        <Row
          style={{
            margin: "20px 0px",
            padding: "0px",
            textAlign: "center",
            background: "white",
            display: "block"
          }}
        >
          <Dropdown
            className="filterDrop"
            style={{
              height: "45px",
              borderRadius: "0",
              margin: "0px 10px 0px 0px ",
              textAlign: "center"
            }}
            placeholder={translate(getLanguage(), "Country")}
            selection
            /* value={this.props.agencies.countryId || country[0]} */
            defaultValue={country[0].value}
            options={country}
            onChange={(event, target) => this.countryChanged(target)}
            selectOnBlur={false}
          />
          <Dropdown
            className="filterDrop"
            style={{
              height: "45px",
              borderRadius: "0",
              margin: "0px 10px 0px 0px ",
              textAlign: "center"
            }}
            placeholder={translate(getLanguage(), "Prefecture")}
            selection
            //value={this.props.agencies.perfectureId}
            options={prefect}
            onChange={(event, target) => this.perfectureChanged(target)}
            selectOnBlur={false}
          />
          <Dropdown
            className="filterDrop"
            style={{
              height: "45px",
              borderRadius: "0",
              margin: "0px 10px 0px 0px ",
              textAlign: "center"
            }}
            placeholder={translate(getLanguage(), "Municipality")}
            selection
            //value={this.props.agencies.municipalityId}
            options={municipal}
            onChange={(event, target) => this.municipalityChanged(target)}
            selectOnBlur={false}
          />
          <Input
            placeholder={translate(getLanguage(), "SearchInput")}
            onChangeText={this.handleChangeText}
          >
            <i aria-hidden="true" className="search icon text-input-icon" />
          </Input>
        </Row>

        <Row style={{ margin: "0px", marginTop: "20px" }}>
          <div className="stepLabel" style={{ margin: "0px" }}>
            {translate(getLanguage(), "Departure")}
          </div>
          {this.state.departureLocation &&
            this.state.arrivalLocation && (
              <div>
                <div className="portName">
                  {this.state.departureLocation.name}
                </div>
                <div className="portArrow">
                  <svg
                    viewBox="0 0 1000 1000"
                    className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
                  >
                    <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
                  </svg>
                </div>
                <div className="portName">
                  {this.state.arrivalLocation.name}
                </div>
              </div>
            )}
          <div className="departureDayLabel">
            {translate(getLanguage(), "Departure Date")}
          </div>
          <div className="departureDayText">
            {this.state.outgoingTrip &&
              moment(
                this.state.outgoingTrip.departureDateTime,
                "YYYY-MM-DD HH:mm:ss"
              ).format("dddd DD MMMM YYYY")}
          </div>
        </Row>

        <Row
          style={{
            margin: "0px",
            marginTop: "20px",
            background: "rgb(140,216,248)",
            padding: "10px 0px",
            color: "rgb(40,76,100)",
            fontWeight: "bold"
          }}
        >
          <Col lg={10} md={10} sm={10} xs={10}>
            <Col lg={5} md={5} sm={5} xs={12} style={{ padding: "0px" }}>
              <div className="">
                {" "}
                {translate(getLanguage(), "Name")} /{" "}
                {translate(getLanguage(), "Address")}{" "}
              </div>
            </Col>
            <Col className="removePaddingsOnXS" lg={4} md={4} sm={4} xs={12}>
              <div className=""> {translate(getLanguage(), "Phone")} </div>
            </Col>
            <Col lg={3} md={3} sm={3} xs={12} style={{ padding: "0px" }}>
              <div className=""> {translate(getLanguage(), "Fax")} </div>
            </Col>
          </Col>
          <Col lg={2} md={2} sm={2} xs={2} style={{ padding: "0px" }}>
            <div className="">
              {" "}
              {translate(getLanguage(), "Online Booking")}{" "}
            </div>
          </Col>
        </Row>

        {agenciesOut}

        <div style={{ marginBottom: "20px" }}>
          <Pagination
            activePage={this.state.activeOutPage}
            itemsCountPerPage={10}
            totalItemsCount={filteredAgenciesOut.length}
            pageRangeDisplayed={5}
            onChange={this.handlePageChangeOut}
          />
        </div>

        {this.state.incomingShipData && (
          <div>
            <Row style={{ margin: "0px", marginTop: "20px" }}>
              <div className="stepLabel" style={{ margin: "0px" }}>
                {translate(getLanguage(), "Return")}
              </div>
              {this.state.departureLocation &&
                this.state.arrivalLocation && (
                  <div>
                    <div className="portName">
                      {this.state.arrivalLocation.name}
                    </div>
                    <div className="portArrow">
                      <svg
                        viewBox="0 0 1000 1000"
                        className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
                      >
                        <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
                      </svg>
                    </div>
                    <div className="portName">
                      {this.state.departureLocation.name}
                    </div>
                  </div>
                )}
              <div className="departureDayLabel">
                {translate(getLanguage(), "Return Date")}
              </div>
              <div className="departureDayText">
                {this.state.incomingTrip &&
                  moment(
                    this.state.incomingTrip.departureDateTime,
                    "YYYY-MM-DD HH:mm:ss"
                  ).format("dddd DD MMMM YYYY")}
              </div>
            </Row>

            <Row
              style={{
                margin: "0px",
                marginTop: "20px",
                background: "rgb(140,216,248)",
                padding: "10px 0px",
                color: "rgb(40,76,100)",
                fontWeight: "bold"
              }}
            >
              <Col lg={10} md={10} sm={10} xs={10}>
                <Col lg={5} md={5} sm={5} xs={12} style={{ padding: "0px" }}>
                  <div className="">
                    {" "}
                    {translate(getLanguage(), "Name")} /{" "}
                    {translate(getLanguage(), "Address")}{" "}
                  </div>
                </Col>
                <Col
                  className="removePaddingsOnXS"
                  lg={4}
                  md={4}
                  sm={4}
                  xs={12}
                >
                  <div className=""> {translate(getLanguage(), "Phone")} </div>
                </Col>
                <Col lg={3} md={3} sm={3} xs={12} style={{ padding: "0px" }}>
                  <div className=""> {translate(getLanguage(), "Fax")} </div>
                </Col>
              </Col>
              <Col lg={2} md={2} sm={2} xs={2} style={{ padding: "0px" }}>
                <div className="">
                  {" "}
                  {translate(getLanguage(), "Online Booking")}{" "}
                </div>
              </Col>
            </Row>

            {agenciesIn}
            <div style={{ marginBottom: "20px" }}>
              <Pagination
                activePage={this.state.activeInPage}
                itemsCountPerPage={10}
                totalItemsCount={filteredAgenciesIn.length}
                pageRangeDisplayed={5}
                onChange={this.handlePageChangeIn}
              />
            </div>
          </div>
        )}

        <Row style={{ margin: "0px", marginTop: "30px", marginBottom: "30px" }}>
          <Button
            style={{ float: "left", position: "relative" }}
            className="searchButton"
            primary
            loading={this.props.isloading}
            onClick={() => this.redirectToShips()}
          >
            {translate(getLanguage(), "Back")}
          </Button>
        </Row>
      </div>
    );
  }
}

export default AgenciesContent;



// WEBPACK FOOTER //
// ./src/components/Pages/Agencies/AgenciesContent.js